import React from 'react';

import ArrowLink from './ArrowLink';
import useTrackAiInsightsPageEvent from './useTrackAiInsightsPageEvent';

export const AI_INSIGHTS_KB_URL = 'https://docs.prerender.io/docs/ai-insights';
const LINK_LABEL = 'Learn more about AI Insights';

function AiInsightsLearnMoreLink() {
  const trackEvent = useTrackAiInsightsPageEvent();

  return (
    <ArrowLink
      href={AI_INSIGHTS_KB_URL}
      label={LINK_LABEL}
      onClick={() => trackEvent('AI Insights: Learn More Clicked')}
    />
  );
}

export default AiInsightsLearnMoreLink;
